/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BaseConfig,
    BaseConfigFromJSON,
    BaseConfigFromJSONTyped,
    BaseConfigToJSON,
    PullRequestConfig,
    PullRequestConfigFromJSON,
    PullRequestConfigFromJSONTyped,
    PullRequestConfigToJSON,
    UserSelector,
    UserSelectorFromJSON,
    UserSelectorFromJSONTyped,
    UserSelectorToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepoConfig
 */
export interface RepoConfig {
    /**
     * 
     * @type {number}
     * @memberof RepoConfig
     */
    version: number;
    /**
     * 
     * @type {BaseConfig}
     * @memberof RepoConfig
     */
    issues: BaseConfig;
    /**
     * 
     * @type {PullRequestConfig}
     * @memberof RepoConfig
     */
    prs: PullRequestConfig;
    /**
     * 
     * @type {UserSelector}
     * @memberof RepoConfig
     */
    maintainers?: UserSelector;
}

export function RepoConfigFromJSON(json: any): RepoConfig {
    return RepoConfigFromJSONTyped(json, false);
}

export function RepoConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepoConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'issues': BaseConfigFromJSON(json['issues']),
        'prs': PullRequestConfigFromJSON(json['prs']),
        'maintainers': !exists(json, 'maintainers') ? undefined : UserSelectorFromJSON(json['maintainers']),
    };
}

export function RepoConfigToJSON(value?: RepoConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'issues': BaseConfigToJSON(value.issues),
        'prs': PullRequestConfigToJSON(value.prs),
        'maintainers': UserSelectorToJSON(value.maintainers),
    };
}

